import { assembleForm } from 'apps/builder/lib/transforms'
import { assemblePdf } from 'apps/easyForm/lib/transforms'
import axios from 'axios'
const { get, post } = axios

const getToken = () => document.querySelector('[name="csrf-token"]').content
const buildHeaders = () => ({
  headers: {
    'Content-Type': 'application/json',
    'X-CSRF-Token': getToken(),
  },
})

export const builderFetch = url => get(url, buildHeaders())

export const fetchForm = form_id =>
  builderFetch(`/api/v3/forms/${form_id}?format=flat`)

export const fetchEasyFormPdf = form_id =>
  builderFetch(`/easy_form_pdf.json?form_id=${form_id}`)

export const fetchEntryTypes = () =>
  builderFetch(`/entry_types/easy_form_types.json`)

export const fetchOperationTypes = () => builderFetch('/operation_types.json')

export const fetchReferenceData = appId =>
  !appId // includes appId === 0
    ? builderFetch(`/api/v3/reference_data`)
    : builderFetch(`/api/v3/reference_data?form_id=${appId}`)

export const saveEasyFormRequest = async (appId, entities, folder_id) => {
  const { pdf, pages, elements, ...formEntities } = entities
  const formData = assembleForm(formEntities)
  const pdfData = await assemblePdf(pdf, pages, elements)

  return post(
    `/forms/${appId}/app_definition_update.json${
      folder_id ? `?folder_id=${folder_id}` : ''
    }`,
    { ...formData, pdf: pdfData },
    buildHeaders()
  )
}
